<div class="last-update">
  <div *ngIf="detailUsers?.updateUserName">
    Last Update by:
    <span class="blue bold">{{ detailUsers?.updateUserName }}</span>
    on:
    <span class="date">{{ detailUsers?.updatedOn | date }}</span>
  </div>
  <div *ngIf="detailUsers?.approverUserName">
    Approved by:
    <span class="blue bold">{{ detailUsers?.approverUserName }}</span>
    on:
    <span class="date">{{ detailUsers?.approvedOn | date }}</span>
  </div>
  <div *ngIf="detailUsers?.supdateUserName">
    Shielding Last Update by:
    <span class="blue bold">{{ detailUsers?.supdateUserName }}</span>
    on:
    <span class="date">{{ detailUsers?.supdatedOn | date }}</span>
  </div>
  <div *ngIf="detailUsers?.sapproverUserName">
    Shielding Approved by:
    <span class="blue bold">{{ detailUsers?.sapproverUserName }}</span>
    on:
    <span class="date">{{ detailUsers?.sapprovedOn | date }}</span>
  </div>
</div>
